import "../../styles/index.css";
import { Box, Typography } from "@mui/material";
import Lottie from "lottie-react";
import hourglassAnimation from "../../assets/json/grey-json.json";
import usePageMeta from "../../utils/usePageMeta";

const Approval = () => {
  usePageMeta("Approval Pending", "Your registration is pending approval for the Gospel and Church Health Framework.");
  return (
    <Box className="approval-container">
      <Box className="circle-timer">
        <Lottie
          animationData={hourglassAnimation}
          loop={true}
          style={{ width: 100, height: 100 }}
        />
      </Box>

      <Box className="contend">
        <Typography variant="h4" className="approval-title">
          Please wait for approval
        </Typography>

        <Typography
          variant="body1"
          className="approval-subtitle"
          sx={{ marginTop: "10px !important" }}
        >
          Your registration has been submitted successfully. Our team will
        </Typography>
        <Typography variant="body1" className="approval-subtitle">
          review your details and confirm your access, typically within 24
          hours.
        </Typography>
      </Box>
    </Box>
  );
};

export default Approval;
